/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputGeoTraceCoreMember
 */
export interface OutputGeoTraceCoreMember {
    /**
     * 
     * @type {string}
     * @memberof OutputGeoTraceCoreMember
     */
    displayName?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCoreMember
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCoreMember
     */
    lon?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCoreMember
     */
    placeId?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCoreMember
     */
    score?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputGeoTraceCoreMember
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputGeoTraceCoreMember
     */
    tokenIndex?: number;
}

/**
 * Check if a given object implements the OutputGeoTraceCoreMember interface.
 */
export function instanceOfOutputGeoTraceCoreMember(value: object): boolean {
    return true;
}

export function OutputGeoTraceCoreMemberFromJSON(json: any): OutputGeoTraceCoreMember {
    return OutputGeoTraceCoreMemberFromJSONTyped(json, false);
}

export function OutputGeoTraceCoreMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputGeoTraceCoreMember {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
        'placeId': json['placeId'] == null ? undefined : json['placeId'],
        'score': json['score'] == null ? undefined : json['score'],
        'text': json['text'] == null ? undefined : json['text'],
        'tokenIndex': json['tokenIndex'] == null ? undefined : json['tokenIndex'],
    };
}

export function OutputGeoTraceCoreMemberToJSON(value?: OutputGeoTraceCoreMember | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'displayName': value['displayName'],
        'lat': value['lat'],
        'lon': value['lon'],
        'placeId': value['placeId'],
        'score': value['score'],
        'text': value['text'],
        'tokenIndex': value['tokenIndex'],
    };
}

